import type { LocationQueryRaw, RouteLocationRaw, Router } from "vue-router";

export default class RouteHelper {
  #router: Router;

  constructor(router: Router) {
    this.#router = router;

    if (!router) {
      throw new Error("Router is required");
    }
  }

  /** Check if a route is the current route (including query params) */
  isCurrentRoute(route: RouteLocationRaw): boolean {
    const newHref = this.#router.resolve(route).href;
    const currentHref = this.#router.currentRoute.value.fullPath;

    return newHref === currentHref;
  }

  /** Push the url with history */
  pushQueryParam(query: LocationQueryRaw) {
    this.#updateQueryParam(query, "push");
  }

  /** Replace the url without history. */
  replaceQueryParam(query: LocationQueryRaw) {
    this.#updateQueryParam(query, "replace");
  }

  /** Will redirect to the route, with removed param  */
  removeQueryParam(param: string): void {
    const currentQuery = { ...this.#router.currentRoute.value.query };
    delete currentQuery[param];

    const newRoute = {
      ...this.#router.currentRoute,
      query: currentQuery
    };

    if (!this.isCurrentRoute(newRoute)) {
      this.#router.push(newRoute);
    }
  }

  /** Gets current query, with optionally added/updated query params */
  getQueryParams(query: LocationQueryRaw): LocationQueryRaw {
    const currentQuery = { ...this.#router.currentRoute.value.query };

    return {
      ...currentQuery,
      ...query
    };
  }

  #updateQueryParam(query: LocationQueryRaw, routerMethod: "push" | "replace"): void {
    const nextQuery = this.getQueryParams(query);

    const newRoute = {
      ...this.#router.currentRoute,
      query: nextQuery
    };

    if (!this.isCurrentRoute(newRoute)) {
      this.#router[routerMethod](newRoute);
    }
  }
}
